import React, { Component } from 'react';
import {
  Icon, List,
  Modal, Radio, WingBlank,
} from 'antd-mobile';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import styles from './index.module.less';
import tools from '../../../utils/tools';

const propTypes = {
  handleChangeOnClose: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  id: PropTypes.number,
  seriesAndCars: PropTypes.objectOf(PropTypes.array),
  name: PropTypes.string,
  seriesName: PropTypes.string,
  CustomerDetail: PropTypes.shape({
    getCustomerDetail: PropTypes.func,
    getModal: PropTypes.func,
  }).isRequired,
};
const defaultProps = {
  handleChangeOnClose: () => {},
  id: 0,
  name: '',
  seriesAndCars: {},
  seriesName: '',
};
/**
 * 车型弹框
 */
@inject('CustomerDetail')
@observer
class AddModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      dataList: [],
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const { id, seriesAndCars } = this.props;
    this.setState({
      dataList: seriesAndCars[id],
    });
  }

  handleChangeRadio = ({ specId, specName }) => {
    const {
      id, name, seriesName, CustomerDetail: customer, history,
    } = this.props;
    const data = {
      appbrandName: name,
      appSpecName: specName,
      appSpecId: specId,
      appSeriesName: seriesName,
      appSeriesId: id,
      carColorId: '',
      interiorColorId: '',
    };
    customer.setCustomerValue(data, 1);
    this.setState({
      value: specId,
    });
    const token = tools.getQueryString('token');
    const userId = tools.getQueryString('userId');
    const phone = tools.getQueryString('phone');
    const weChat = tools.getQueryString('weChat');
    history.push(`/customerDetail?token=${token}&userId=${userId}&phone=${phone}&id=${specId}&seriesId=${id}&weChat=${weChat}`);
  }

  handleChangeClose = (e) => {
    e.preventDefault();
    const { handleChangeOnClose } = this.props;
    handleChangeOnClose();
  }

  renderRadioItem = () => {
    const { dataList, value } = this.state;
    return dataList.map((item) => (
      <Radio.RadioItem
        checked={value === item.specId}
        onChange={() => this.handleChangeRadio(item)}
        key={item.specId}
      >
        {item.specName }
      </Radio.RadioItem>
    ));
  }

  render() {
    const { name } = this.props;
    return (
      <Modal
        popup
        visible
        animationType="slide-up"
        className={styles.modalContentRadius}
        maskClosable={false}
        onClose={this.handleChangeClose}
      >
        <div className={styles.invoiceContent}>
          <div className={styles.headers}>
            <p className={styles.headerFont}>
              {name}
              系列
            </p>
            <span className={styles.close} onTouchStart={(event) => event.preventDefault()} onClick={this.handleChangeClose} role="button" tabIndex="0">
              <Icon type="cross" />
            </span>
          </div>
          <WingBlank>
            <List>
              {this.renderRadioItem()}
            </List>
          </WingBlank>
        </div>
      </Modal>
    );
  }
}

AddModal.propTypes = propTypes;
AddModal.defaultProps = defaultProps;
export default AddModal;
